const router = [
  {
    meta: {
      icon: "iconfont iconjichuxinxiguanli",
      title: "全民营销",
      uri: "/newRetail/marketing",
    },
    subMenus: [
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "平台用户管理",
          uri: "/newRetail/marketing/userManagerList",
        },
        component: () => import("./userManagerList"),
        path: "/userManagerList",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "营销素材库",
          uri: "/newRetail/marketing/materialLibrary",
        },
        component: () => import("./materialLibrary"),
        path: "/materialLibrary",
      },
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "素材发布管理",
          uri: "/newRetail/marketing/materialPublishManager",
        },
        component: () => import("./materialPublishManager"),
        path: "/materialPublishManager",
      },
    ],
  },
];

export default router;
